import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { MissionSection } from './components/MissionSection';
import { CompetenciesSection } from './components/CompetenciesSection';
import { CypressSection } from './components/CypressSection';
import { SESLeadershipSection } from './components/SESLeadershipSection';
import { CrisisSection } from './components/CrisisSection';
import { ArmyLeadershipSection } from './components/ArmyLeadershipSection';
import { BoardsSection } from './components/BoardsSection';
import { MetricsSection } from './components/MetricsSection';
import { AwardsSection } from './components/AwardsSection';
import { EducationSection } from './components/EducationSection';
import { MediaSection } from './components/MediaSection';
import { ServicesSection } from './components/ServicesSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-white selection:bg-gold-500 selection:text-navy-900" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <MissionSection data-id="element-4" />
        <CompetenciesSection data-id="element-5" />
        <CypressSection data-id="element-6" />
        <SESLeadershipSection data-id="element-7" />
        <CrisisSection data-id="element-8" />
        <ArmyLeadershipSection data-id="element-9" />
        <BoardsSection data-id="element-10" />
        <MetricsSection data-id="element-11" />
        <AwardsSection data-id="element-12" />
        <EducationSection data-id="element-13" />
        <MediaSection data-id="element-14" />
        <ServicesSection data-id="element-15" />
        <ContactSection data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}